
import { defineComponent, onMounted, ref, reactive } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as Yup from "yup";
import { useToast } from "vue-toastification";
import ApiService from "@/core/services/ApiService";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

import FormEdit from "@/components/1crm/sales/sales-area/edit-sales-area.vue";

export default defineComponent({
  name: "Cabang",
  components: {
    ErrorMessage,
    Field,
    Form,
    FormEdit
  },

  setup() {
    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH_USER);
      setCurrentPageBreadcrumbs("Sales Area", ["Data"]);
    });

    return {

    };
  },
});
